import { Fragment } from "react";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/common/ui/breadcrumb";

import type { OrgUnit } from "../types";

interface OrgBreadcrumbProps {
  selectedNode: OrgUnit | null;
  tree: OrgUnit;
  onNavigate: (node: OrgUnit) => void;
}

function findPath(tree: OrgUnit, targetId: string, path: OrgUnit[] = []): OrgUnit[] | null {
  const currentPath = [...path, tree];

  if (tree.id === targetId) {
    return currentPath;
  }

  for (const child of tree.children) {
    const result = findPath(child, targetId, currentPath);
    if (result) return result;
  }

  return null;
}

export function OrgBreadcrumb({
  selectedNode,
  tree,
  onNavigate,
}: OrgBreadcrumbProps): React.ReactElement | null {
  if (!selectedNode) return null;

  const path = findPath(tree, selectedNode.id) ?? [];

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {path.map((node, index) => (
          <Fragment key={node.id}>
            {index > 0 && <BreadcrumbSeparator />}
            <BreadcrumbItem>
              {index === path.length - 1 ? (
                <BreadcrumbPage>{node.name}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink asChild>
                  <button type="button" onClick={() => onNavigate(node)}>
                    {node.name}
                  </button>
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
